/* global $ */

let currentID = 1;
$.$body.find('.video-share .videoWrapper iframe').each(function () {
	$(this).attr('id', currentID);
	$(this).attr('src', $(this).attr('src') + '&autoplay=0');
	$(this).attr('src', $(this).attr('src') + '&rel=0');
	currentID++;
});

let current = 1;
$.$body
	.find('.video-cover')
	.not('.fancybox-active')
	.each(function () {
		const findVideo = $('#' + current);
		$(this).click(function () {
			$(this).fadeOut();
			$(findVideo).attr(
				'src',
				String($(findVideo).attr('src')).replace(
					'autoplay=0',
					'autoplay=1'
				)
			);
		});
		current++;
	});

// fix popover iframes
$.$body.find('.pop-over .videoWrapper iframe').each(function () {
	$(this).attr('id', currentID);
	$(this).attr('src', $(this).attr('src') + '&autoplay=1');
	$(this).attr('src', $(this).attr('src') + '&rel=0');
	currentID++;
});

$(document).on('click touchstart', (event) => {
	if (!$(event.target).closest('.pop-over .videoWrapper iframe').length) {
		if ($('.pop-over').is(':visible')) {
			$('.pop-over').hide();
			const iFrameSrc = $('.pop-over .videoWrapper iframe').attr('src');
			if (iFrameSrc) {
				$('.pop-over .videoWrapper iframe').attr(
					'src',
					iFrameSrc.replace('autoplay=1', 'autoplay=0')
				);
			}
		}
	}
});

$.$body.find('.play-button').click((event) => {
	if (!$(event.target).closest('.pop-over .videoWrapper iframe').length) {
		if ($('.pop-over').is(':visible')) {
			$('.pop-over').hide();
		}
	}
});

$.$body.find('.featured-image--video').on('click', function () {
	$(this).find('.video-wrapper').show();
});

// prevent ambient video from being played by default, saving data.
function playVideo($video) {
	$video
		.prop('autoplay', true)
		.attr('preload', 'auto')
		.removeClass('unplayed');
	const video = $video.get(0);
	if (video && typeof video.play === 'function') {
		video.play();
	}
}

const $videos = $('body').find('video');
function playVideosIfVisible() {
	if ($videos.filter('.unplayed').length) {
		$('body')
			.find('video')
			.filter('.unplayed')
			.each((i, el) => {
				const $video = $(el);
				if ($video.css('display') === 'block') {
					playVideo($video);
				}
			});
	} else {
		$(window).off('resize', playVideosIfVisible);
	}
}

if ($videos.length) {
	$(window).resize(playVideosIfVisible);
	playVideosIfVisible();
}

const topperSection = document.querySelector('.topper');
const topperVideo = document.querySelector('.fullscreen-bg__video');
const playPauseTopper = document.querySelector('.topper-pause');
const playPauseTopperText = document.querySelector('.button-text');

if (playPauseTopper) {
	topperVideo.classList.toggle('video-ready');

	playPauseTopper.addEventListener('click', pauseTopper);

	// featureVideoPlay.addEventListener('click', pauseOnStart);

	function toggleTopperClass() {
		topperSection.classList.toggle('video-paused');
	}

	function pauseTopper() {
		toggleTopperClass();
		if (topperVideo.paused) {
			topperVideo.play();
			playPauseTopperText.innerText = 'Pause';
		} else {
			topperVideo.pause();
			playPauseTopperText.innerText = 'Play';
		}
	}

	// function pauseOnStart() {
	// 	if (topperVideo.play()) {
	// 		toggleTopperClass();
	// 		topperVideo.pause();
	// 		playPauseTopperText.innerText = 'Play';
	// 	}
	// }
}

/**
 * Small func to iterate over source elems and set the src to the data-src.
 *
 * @param {Node} video - The video element.
 */
function swapSrcAndPlay(video) {
	for (const source in video.children) {
		const videoSource = video.children[source];
		if (
			typeof videoSource.tagName === 'string' &&
			videoSource.tagName === 'SOURCE'
		) {
			videoSource.src = videoSource.dataset.src;
		}
	}
	video.load();
	video.classList.remove('lazy');
	video.onloadeddata = function () {
		$(video).closest('.video-container').addClass('video-loaded');
		// video.classList.add('video-loaded');
		video.play();
	};
}

/**
 * Hanlde lazy loading the topper videos.
 * Add class 'lazy' to video and set source src to data-src.
 */
document.addEventListener('DOMContentLoaded', function () {
	const lazyVideos = [].slice.call(document.querySelectorAll('video.lazy'));

	// Set up intersection observer.
	if ('IntersectionObserver' in window) {
		const lazyVideoObserver = new IntersectionObserver(function (entries) {
			entries.forEach(function (video) {
				if (video.isIntersecting) {
					swapSrcAndPlay(video.target);
					lazyVideoObserver.unobserve(video.target);
				}
			});
		});
		lazyVideos.forEach((lazyVideo) => {
			lazyVideoObserver.observe(lazyVideo);
		});
	} else {
		// Possibly fall back to a more compatible method here
		lazyVideos.forEach((lazyVideo) => {
			swapSrcAndPlay(lazyVideo);
		});
	}
});
